module.exports = __webpack_public_path__ + "static/img/迈拓模块.5eca6c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/迈拓模块.png
// module id = Ws0q
// module chunks = 1